import { StatusCodes } from "http-status-codes";
import { request } from "../api";
import { headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import { AUTHORIZATION } from "../../../constants/api/auth";

const { post, get, patch, put } = request;
const { Authorization, Bearer } = AUTHORIZATION;

export type CheckPreviousVEBEnrollmentQueryTypes = {
	group_number: number;
	insured_SSN: string;
};

const initialRoute = "member";

// eslint-disable-next-line arrow-parens
export const getCheckPreviousVEBEnrollment = async (
	CheckPreviousVEBEnrollmentQuery: CheckPreviousVEBEnrollmentQueryTypes
) => {
	try {
		const endpoint = `${initialRoute}/enrollment/check-previous-veb-enrollment`;
		const token = localStorage.getItem("@jwt_member");
		const response = await get(
			endpoint,
			{
				...headers,
				[Authorization]: `${Bearer} ${token}`
			},
			CheckPreviousVEBEnrollmentQuery
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			} else if (message === MESSAGE.get.fail) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			alert(message);
		} else {
			throw error;
		}
	}
};

export const getActiveVEBEnrollmentWithRider = async (
	CheckPreviousVEBEnrollmentQuery: CheckPreviousVEBEnrollmentQueryTypes
) => {
	try {
		const endpoint = `${initialRoute}/enrollment/get-active-veb-enrollments-with-rider`;
		const token = localStorage.getItem("@jwt_member");
		const response = await get(
			endpoint,
			{
				...headers,
				[Authorization]: `${Bearer} ${token}`
			},
			CheckPreviousVEBEnrollmentQuery
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			} else if (message === MESSAGE.get.fail) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			alert(message);
		} else {
			throw error;
		}
	}
};
